import PropTypes from "prop-types";

// SSR checks propsTypes where HTMLElement is not available
export const htmlElementPropType =
  typeof HTMLElement === "undefined" ? PropTypes.object : PropTypes.instanceOf(HTMLElement);
